var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-button"},[_c('button',{staticClass:"video-button__button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('icon',{staticClass:"video-button__button-icon",attrs:{"name":"play"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }